import { useAppSelector } from '@/redux/hooks'
import { Roles } from '@/utils'
import { useInvoicedPortals } from './use-invoiced-portals'

// Billing is shown wherever there is something to bill: the store in view, or any portal of the group.
// A failed lookup keeps it, so a hiccup does not take a section out of the navigation.
// Shared by the navbar and the blocked overlay so they never disagree.
export const useShowBilling = () => {
  const role = useAppSelector((s) => s.userApi.getMe.response.user?.role)
  const { invoicedPortals, portalsError } = useInvoicedPortals()
  return (
    role === Roles.ReadWrite &&
    (invoicedPortals.length > 0 || Boolean(portalsError))
  )
}
